(function () {
    "use strict";

    Components.YahooRedirect = {
        controller: "YahooRedirectController",
        name: "hbYahooRedirect",
        templateUrl:
            "angular/app/modules/core/features/yahoo_integration/yahoo_redirect_page_template.html",
    };
})();
